import * as React from 'react';
import * as request from 'superagent';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';
import PortalUserSubscription from '~common/lib/models/portal-user-subscription';
import {Paper} from '@mui/material';
import {Typography} from '@mui/material';




const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
	location: any;
}

type State = {
	status: 'ready' | 'loading';
	error?: any;
};

class UnsunscribeView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			status: 'loading',
		};
	}

	componentDidMount() {

    const {match} = this.props;
		request.put(`/api/portal-user-subscriptions/unsubscribe/${match.params.id}`)
		.then((response: request.Response)=>{
			this.setState({status: "ready"})
		}).catch((err)=>{
			this.handleAPIError(err)
		})

	}


    handleAPIError = (err: any, terminal?: boolean) => {
		this.setState({
			error: err
		})
	};


    handleErrorClose = () => {
        this.setState({error:undefined})
    }

	render() {

		const { classes }: { classes: ClassNameMap } = this.props;
		const { status, subscription, error } = this.state;
	

		if (status == 'loading') {
            if (error) {
                return <ErrorView classes={{}} onClose={this.handleErrorClose} error={error} />
            }
			return <LoadingView classes={{}} />;
		}
	
		return (
			<div className={classes.container}>
				<AppView history={this.props.history}>
                    {error && <ErrorView classes={{}} onClose={this.handleErrorClose} error={error} />}
					<Paper elevation={0}>
						<Typography variant="h5" style={{textAlign: 'center', marginTop: 20}}>
                            You have been unsubcribed from this email. 
						</Typography>
					</Paper>
				</AppView>
			</div>
		);
	}
}

export default withStyles(styles)(UnsunscribeView);
